// extracted by mini-css-extract-plugin
export default {"containerBtnPDF":"RowTablaItemCriterio_containerBtnPDF__Yv0i3","buttonPdf":"RowTablaItemCriterio_buttonPdf__D+FTe"};